import Api from '@/services/api'

export default {
  register(params) {
    return Api().post('register', params)
  },
  login(params) {
    return Api().post('login', params)
  },
  forgot(params) {
    return Api().post('forgot', params)
  },
  forgot_check(params) {
    return Api().post('forgot_check', params)
  },
  reset_password(params) {
    return Api().post('reset_password', params)
  },
  refresh(params) {
    return Api().post('refresh', params)
  },
  is_premium(params) {
    return Api().get('premium/check', params)
  },
  is_site_locked(params) {
    return Api().get('locked/check', params)
  },
  locked_login(params) {
    return Api().post('locked/login', params)
  },
  isLoggedIn(params) {
    return Api().get('loggedin', params)
  }
}